"use client";
import React from "react";
import { useState } from "react";
import { AnimatePresence, LazyMotion, m, domAnimation } from "framer-motion";
export const faqData = {
  title: "Frequently Asked Questions",
  questions: [
    {
      question: "What is the maximum booking duration?",
      answer:
        "The maximum booking duration for short-let properties is 3 months. For long-term rentals, lease agreements vary based on the property.",
    },
    {
      question: "What are the check-in and check-out times?",
      answer:
        "Check-in time is 2:00 PM, and check-out is by 11:00 AM. Late check-outs may be available upon request.",
    },
    {
      question: "Is there a security deposit required?",
      answer:
        "Yes, a refundable security deposit is required for short-let bookings. The amount depends on the property and will be refunded upon check-out after inspection.",
    },
    {
      question: "Are utilities included in the rent?",
      answer:
        "For short-let properties, utilities such as electricity, water, and internet are included. For long-term rentals, tenants are responsible for their own utility bills unless otherwise stated.",
    },
    {
      question: "What is the cancellation policy?",
      answer:
        "Cancellations made at least 7 days before check-in will receive a full refund. Cancellations within 7 days of check-in may be subject to partial or no refunds.",
    },
    {
      question: "Are pets allowed?",
      answer:
        "Pet policies vary by property. Some properties allow pets with an additional deposit, while others have a strict no-pet policy.",
    },
    {
      question: "Do you offer housekeeping services?",
      answer:
        "Yes, complimentary housekeeping is provided for short-let stays. Additional cleaning services can be arranged for an extra fee.",
    },
    {
      question: "Is parking available?",
      answer:
        "Most properties offer free on-site parking, but availability may be limited. Please check the property details or contact us for confirmation.",
    },
  ],
};
interface AccordionProps {
  data: {
    title: string;
    questions: { question: string; answer: string }[];
  };
}
const Accordion: React.FC<AccordionProps> = ({ data }) => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const toggleAccordion = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return (
    <LazyMotion features={domAnimation}>
      <div className="w-full bg-white p-4 border rounded-2xl shadow-lg">
        <h2 className="text-xl font-semibold mb-4">{data.title}</h2>
        {data.questions.map((item, index) => (
          <div key={index} className="border-b py-2 last:border-none">
            <button
              onClick={() => toggleAccordion(index)}
              className="w-full text-left transition-all text-secondary-main duration-500 flex justify-between items-center"
            >
              {item.question}
              <span className="text-themeColor text-2xl">
                {openIndex === index ? "-" : "+"}
              </span>
            </button>
            <AnimatePresence>
              {openIndex === index && (
                <m.div
                  initial={{ opacity: 0, height: 0 }}
                  animate={{ opacity: 1, height: "auto" }}
                  transition={{
                    duration: 0.3,
                    ease: "easeInOut",
                  }}
                  exit={{ opacity: 0, height: 0 }}
                  className="pl-4 text-secondary-main"
                >
                  {item.answer}
                </m.div>
              )}
            </AnimatePresence>
          </div>
        ))}
      </div>
    </LazyMotion>
  );
};
export default Accordion;
